/* Dedicated ZOLEO product header/footer. No source-site sales or service redirects. */
(() => {
  'use strict';
  const translations = window.ZoleoOfferTranslations || {}
  window.ZoleoTranslations = translations;


  let language = 'en';
  let activeInfo = '';
  let infoTrigger = null;
  const t = key => translations[language][key] || translations.en[key] || key;
  const preferredLanguage = value => {
    const normalized = String(value || '').toLowerCase().split('-')[0];
    return translations[normalized] ? normalized : 'de';
  };
  function setLanguage(value) {
    language = preferredLanguage(value);
    document.querySelectorAll('[data-zoleo-t]').forEach(node => { node.textContent = t(node.dataset.zoleoT); });
    document.querySelectorAll('[data-zoleo-placeholder]').forEach(node => { node.placeholder = t(node.dataset.zoleoPlaceholder); });
    document.querySelectorAll('[data-zoleo-aria]').forEach(node => { node.setAttribute('aria-label', t(node.dataset.zoleoAria)); });
    const code = document.querySelector('.zc-language-code');
    if (code) code.textContent = language.toUpperCase();
    if (activeInfo && document.getElementById('ZoleoInformation')?.open) populateInfo(activeInfo);
    return language;
  }
  const countryLanguage = {DE:'de',AT:'de',RO:'ro',PT:'pt-PT',HR:'hr',HU:'hu',CZ:'cs',PL:'pl'};
  const marketCurrency = {DE:'EUR',AT:'EUR',RO:'RON',PT:'EUR',HR:'EUR',HU:'HUF',CZ:'CZK',PL:'PLN'};
  function draftSafeReturnTo(hash = '') {
    const current = new URL(location.href);
    const next = new URL(current.pathname, current.origin);
    ['preview_theme_id','preview_key','products_preview','variant','view','offer'].forEach(key => {
      if (current.searchParams.has(key)) next.searchParams.set(key,current.searchParams.get(key));
    });
    next.hash = hash;
    return next.pathname + next.search + next.hash;
  }
  function preserveReturnTo(form, hash = '') {
    if (!form) return;
    let field = form.querySelector('input[name="return_to"]');
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; form.append(field); }
    field.value = draftSafeReturnTo(hash);
  }
  function hasOption(select, value) {
    return Boolean(select && Array.from(select.options).some(option => option.value === value));
  }
  function syncLocalizationPair(value) {
    const market = document.getElementById('ZoleoMarket');
    const country = document.getElementById('ZoleoCountry');
    const locale = document.getElementById('ZoleoLanguage');
    const option = market && Array.from(market.options).find(item => item.value === value);
    if (!country || !locale || !option || option.disabled || option.dataset.language !== countryLanguage[value] || option.dataset.currency !== marketCurrency[value]) return false;
    market.value = value;
    country.value = value;
    locale.value = countryLanguage[value];
    const status = document.querySelector('.zc-localization-status');
    if (status) { status.hidden = true; status.textContent = ''; }
    return true;
  }
  function initializeLocalization() {
    const market = document.getElementById('ZoleoMarket');
    const country = document.getElementById('ZoleoCountry');
    const actualCountry = document.getElementById('zoleo-header')?.dataset.country || window.ZoleoConfig?.country || country?.value;
    if (!market) return;
    market.value = hasOption(market,actualCountry) ? actualCountry : '';
    if (market.value) syncLocalizationPair(market.value);
  }
  function validateLocalization() {
    const market = document.getElementById('ZoleoMarket');
    const country = document.getElementById('ZoleoCountry');
    const locale = document.getElementById('ZoleoLanguage');
    return Boolean(market?.value && country?.value === market.value && countryLanguage[market.value] === locale?.value);
  }
  function closeMenu() {
    const header = document.getElementById('zoleo-header');
    header?.classList.remove('is-menu-open');
    const toggle = header?.querySelector('.zc-mobile-toggle');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', t('menu'));
    document.documentElement.classList.remove('zc-menu-open');
  }
  function closePanels(exception) {
    document.querySelectorAll('.zc-menu-has-panel').forEach(item => {
      if (item === exception) return;
      item.classList.remove('is-open');
      item.querySelector('.zc-menu-link')?.setAttribute('aria-expanded', 'false');
    });
  }
  function togglePanel(item, open) {
    closePanels(item);
    item.classList.toggle('is-open', open);
    item.querySelector('.zc-menu-link')?.setAttribute('aria-expanded', String(open));
  }
  function showDialog(dialog, trigger) {
    if (!dialog) return;
    infoTrigger = trigger || document.activeElement;
    closeMenu();
    closePanels();
    if (!dialog.open) dialog.showModal();
  }
  function populateInfo(key) {
    const title = document.getElementById('ZoleoInformationTitle');
    const body = document.getElementById('ZoleoInformationBody');
    if (!title || !body) return;
    const prefix = ({contact:'contact',newsletter:'newsletter',network:'network',business:'business',tracking:'tracking',messaging:'messaging',sos:'sos',warranty:'warranty',plans:'plans',activation:'activation',faq:'faq',accessibility:'accessibility',cookies:'cookie'})[key] || 'faq';
    title.textContent = t(prefix + 'Title');
    body.replaceChildren();
    if (key === 'plans') {
      const intro = document.createElement('p'); intro.textContent = t('previewPlansIntro'); body.append(intro);
      const packages = document.createElement('ul'); packages.className = 'zop-plan-list';
      [['Short','2m'],['Long','24m']].forEach(([suffix, offer]) => {
        const item = document.createElement('li'); item.dataset.offerTerm = offer;
        const name = document.createElement('strong'); name.textContent = t('previewPlan' + suffix);
        const price = document.createElement('span'); price.textContent = window.ZoleoOfferCatalog?.offers?.[offer]?.formatted_price_with_currency || '—';
        const term = document.createElement('p'); term.textContent = t('previewPlanTerm' + suffix);
        item.append(name,price,term); packages.append(item);
      });
      body.append(packages);
      ['previewPlansRenewal','previewPlansActivation','previewPlansWarranty'].forEach(key => {
        const paragraph = document.createElement('p'); paragraph.textContent = t(key); body.append(paragraph);
      });
    } else {
      const paragraph = document.createElement('p'); paragraph.textContent = t(prefix + 'Body'); body.append(paragraph);
    }
    const contact = document.querySelector('.zc-information-contact'); if (contact) contact.hidden = key !== 'contact';
    const policy = document.querySelector('.zc-information-policy'); if (policy) policy.hidden = key !== 'warranty';
    const privacy = document.querySelector('.zc-information-privacy'); if (privacy) privacy.hidden = !['newsletter','cookies'].includes(key);
    if (key === 'cookies') {
      const actions = document.createElement('div'); actions.className = 'zc-cookie-actions';
      [['cookieAccept',true],['cookieReject',false]].forEach(([label, consent]) => {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = t(label);
        button.addEventListener('click', () => saveCookieConsent(consent, body, actions)); actions.append(button);
      });
      body.append(actions);
    }
  }
  function openInfo(key, trigger) {
    activeInfo = key;
    populateInfo(key);
    showDialog(document.getElementById('ZoleoInformation'), trigger);
  }
  async function privacyApi() {
    if (window.Shopify?.customerPrivacy) return window.Shopify.customerPrivacy;
    if (!window.Shopify?.loadFeatures) throw new Error('Privacy API unavailable');
    await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Privacy API timed out')),10000);
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { clearTimeout(timer); error ? reject(error) : resolve(); });
    });
    if (!window.Shopify.customerPrivacy) throw new Error('Privacy API unavailable');
    return window.Shopify.customerPrivacy;
  }
  async function saveCookieConsent(consent, body, actions) {
    actions.querySelectorAll('button').forEach(button => button.disabled = true);
    let status = body.querySelector('[role=status]');
    if (!status) { status = document.createElement('p'); status.setAttribute('role','status'); body.append(status); }
    try {
      const api = await privacyApi();
      await new Promise((resolve,reject) => {
        const timer = setTimeout(() => reject(new Error('Consent save timed out')),10000);
        api.setTrackingConsent({analytics:consent,marketing:consent,preferences:consent}, () => { clearTimeout(timer); resolve(); });
      });
      const saved = api.currentVisitorConsent?.();
      const expected = consent ? 'yes' : 'no';
      if (!saved || !['analytics','marketing','preferences'].every(key => saved[key] === expected)) throw new Error('Consent was not confirmed');
      status.textContent = t('cookieSaved');
    } catch (_) { status.textContent = t('cookieUnavailable'); }
    actions.querySelectorAll('button').forEach(button => button.disabled = false);
  }
  async function subscribe(event) {
    const form = event.currentTarget;
    preserveReturnTo(form,'ZoleoNewsletter');
    if (form.dataset.submitMode === 'native') return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    if (!form.reportValidity()) return;
    const submit = form.querySelector('button[type=submit]');
    const status = form.querySelector('.zc-newsletter-status');
    form.dataset.submitting = 'true'; submit.disabled = true;
    const beforeText = submit.textContent; submit.textContent = t('newsletterBusy');
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(),20000);
    try {
      const action = new URL(form.action,location.href);
      if (action.origin !== location.origin) throw new Error('Unexpected newsletter endpoint');
      const body = new URLSearchParams(new FormData(form));
      const response = await fetch(action.href, {method:'POST',body,credentials:'same-origin',headers:{'Accept':'text/html'},signal:controller.signal});
      if (!response.ok || new URL(response.url).origin !== location.origin) throw new Error('Newsletter response was not confirmed');
      const result = new DOMParser().parseFromString(await response.text(), 'text/html');
      const serverStatus = result.querySelector('#ZoleoNewsletter .zc-newsletter-status');
      if (serverStatus?.dataset.serverState === 'success') {
        status.dataset.serverState = 'success'; status.textContent = t('newsletterSuccess');
      } else if (serverStatus?.dataset.serverState === 'error') {
        status.dataset.serverState = 'error'; status.replaceChildren(...Array.from(serverStatus.childNodes));
      } else {
        /* A challenge or an unrecognized response is not a successful subscription. */
        form.dataset.submitMode = 'native'; status.dataset.serverState = 'error'; status.textContent = t('newsletterError');
      }
    } catch (_) {
      form.dataset.submitMode = 'native'; status.dataset.serverState = 'error'; status.textContent = t('newsletterError');
    } finally { clearTimeout(timer); delete form.dataset.submitting; submit.disabled = false; submit.textContent = beforeText; }
  }
  function init() {
    const header = document.getElementById('zoleo-header');
    if (!header || header.dataset.chromeReady === 'true') return;
    header.dataset.chromeReady = 'true';
    setLanguage(window.ZoleoConfig?.language || window.ZoleoConfig?.locale || document.documentElement.dataset.zoleoLanguage || header.dataset.language || document.documentElement.lang);
    initializeLocalization();
    const mobile = header.querySelector('.zc-mobile-toggle');
    mobile?.addEventListener('click', () => {
      const open = !header.classList.contains('is-menu-open');
      header.classList.toggle('is-menu-open', open);
      document.documentElement.classList.toggle('zc-menu-open', open);
      mobile.setAttribute('aria-expanded', String(open)); mobile.setAttribute('aria-label', t(open ? 'closeMenu' : 'menu'));
    });
    header.querySelectorAll('.zc-menu-has-panel').forEach(item => {
      const control = item.querySelector('.zc-menu-link');
      control.addEventListener('click', () => togglePanel(item, !item.classList.contains('is-open')));
      item.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && matchMedia('(min-width:1025px)').matches) togglePanel(item, true); });
      item.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && matchMedia('(min-width:1025px)').matches) togglePanel(item, false); });
      item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) togglePanel(item, false); });
    });
    document.querySelector('[data-zoleo-close-menu]')?.addEventListener('click', closeMenu);
    matchMedia('(min-width:1025px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
    document.querySelectorAll('.zc-dialog').forEach(dialog => {
      dialog.querySelector('[data-zoleo-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { activeInfo = ''; infoTrigger?.focus?.(); });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    });
    const footerSmall = matchMedia('(max-width:600px)');
    document.querySelectorAll('.zc-footer-column h2').forEach(title => {
      const updateTitle = () => {
        if (footerSmall.matches) { title.setAttribute('tabindex','0'); title.setAttribute('role','button'); title.setAttribute('aria-expanded',String(title.parentElement.classList.contains('is-open'))); }
        else { title.removeAttribute('tabindex'); title.removeAttribute('role'); title.removeAttribute('aria-expanded'); }
      };
      updateTitle(); footerSmall.addEventListener('change',updateTitle);
      const toggle = () => { if (matchMedia('(max-width:600px)').matches) { const open = title.parentElement.classList.toggle('is-open'); title.setAttribute('aria-expanded',String(open)); } };
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); } });
    });
    document.addEventListener('click', event => {
      const info = event.target.closest('[data-zoleo-info]');
      if (info) { event.preventDefault(); openInfo(info.dataset.zoleoInfo, info); return; }
      const localization = event.target.closest('[data-zoleo-localization]');
      if (localization) { event.preventDefault(); showDialog(document.getElementById('ZoleoLocalization'),localization); return; }
      if (event.target.closest('[data-zoleo-cookie-settings]')) { event.preventDefault(); openInfo('cookies',event.target.closest('button')); return; }
      const link = event.target.closest('.zc-header a[href^="#"],.zc-footer a[href^="#"]');
      if (link) {
        const anchor = link.getAttribute('href').slice(1);
        const target = document.getElementById(anchor);
        if (target) {
          event.preventDefault(); closeMenu(); closePanels();
          if (target.closest('[data-zoleo-product]')) document.dispatchEvent(new CustomEvent('zoleo:open-section',{detail:{id:anchor}}));
          else target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
          history.replaceState(null,'','#'+anchor);
        }
        else if (anchor === 'top') { event.preventDefault(); closeMenu(); window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}); }
        else if (['plans','activation','faq'].includes(anchor)) { event.preventDefault(); openInfo(anchor,link); }
      }
      if (!event.target.closest('.zc-menu-has-panel')) closePanels();
    });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeMenu(); closePanels(); } });
    document.getElementById('ZoleoNewsletter')?.addEventListener('submit', subscribe);
    preserveReturnTo(document.getElementById('ZoleoNewsletter'),'ZoleoNewsletter');
    preserveReturnTo(document.getElementById('ZoleoLocalizationForm'));
    document.getElementById('ZoleoMarket')?.addEventListener('change', event => {
      if (!syncLocalizationPair(event.target.value)) return;
      const form = document.getElementById('ZoleoLocalizationForm');
      if (form?.requestSubmit) form.requestSubmit();
      else form?.querySelector('button[type="submit"]')?.click();
    });
    document.getElementById('ZoleoLocalizationForm')?.addEventListener('submit', event => {
      preserveReturnTo(event.currentTarget);
      if (!syncLocalizationPair(document.getElementById('ZoleoMarket')?.value) || !validateLocalization()) {
        event.preventDefault();
        const status = document.querySelector('.zc-localization-status');
        if (status) { status.textContent = t('localizationUnavailable'); status.hidden = false; }
      }
    });
    const accountComponents = Array.from(header.querySelectorAll('shopify-account'));
    const accountFallbacks = Array.from(header.querySelectorAll('[data-zoleo-account-fallback]'));
    accountFallbacks.forEach(link => {
      const url = new URL(link.href,location.href);
      if (url.pathname.endsWith('/customer_authentication/login')) { url.searchParams.set('return_to',draftSafeReturnTo()); link.href = url.href; }
    });
    if (accountComponents.length && accountFallbacks.length && window.customElements) {
      const showFallback = () => {
        const ready = Boolean(customElements.get('shopify-account'));
        accountComponents.forEach(component => component.hidden = !ready);
        accountFallbacks.forEach(link => link.hidden = ready);
      };
      const timer = setTimeout(showFallback,3000);
      customElements.whenDefined('shopify-account').then(() => { clearTimeout(timer); showFallback(); });
    }
    document.addEventListener('zoleo:language', event => { if (event.detail?.language || event.detail?.locale) setLanguage(event.detail.language || event.detail.locale); });
  }
  window.ZoleoChrome = {setLanguage,openInfo,closeMenu,translations};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
